module.exports = __webpack_public_path__ + "fonts/52b66b1cd3f40798297a579ce4075dde.svg";